import styled, { css } from "styled-components";

import { colors } from "../theme/colors";

export const BlueGradient = styled.span`
  ${colors.blueGradient};
`;

export const BlueText = styled.span`
  color: ${({ theme }) => theme.colors.vividBlue};
`;

export const GreenText = styled.span`
  color: ${({ theme }) => theme.colors.green};
`;

export const LightSecondaryText = styled.span`
  color: ${({ theme }) => theme.colors.lightSecondary};
`;

export const PositiveNumber = styled.span<{ $hasDarkBackground?: boolean }>(
  ({ $hasDarkBackground, theme }) => css`
    color: ${$hasDarkBackground
      ? theme.colors.lightPositive
      : theme.colors.positive};
  `,
);

export const NegativeNumber = styled.span<{ $hasDarkBackground?: boolean }>(
  ({ $hasDarkBackground, theme }) => css`
    color: ${$hasDarkBackground
      ? theme.colors.lightNegative
      : theme.colors.negative};
  `,
);

export const NeutralNumber = styled.span`
  color: rgba(255, 255, 255, 0.7);
`;
